module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("To Steve, Joshua, & Owen—my boys with the biggest hearts with the greatest abundance for love who fill my bucket every day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c76fd43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Dedication.vue
// module id = 69
// module chunks = 0